import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CardUIType, PlaylistCardShort } from '@app/app/shared/models';

@Component({
  selector: 'ptl-card-item-list-view',
  templateUrl: './card-item-list-view.component.html',
  styleUrls: ['./card-item-list-view.component.scss'],
})
export class CardItemListViewComponent {
  @Input() card: PlaylistCardShort;
  @Input() cardType: CardUIType = 'general';
  @Input() cardIndex = 0;
  @Input() showMeta = true;
  @Input() showReviews = true;
  @Input() showProgressLine = true;

  @Output() cardClick = new EventEmitter<PlaylistCardShort>();
}
